import { render, staticRenderFns } from "./DocumentInvite.vue?vue&type=template&id=c0a1c32c"
import script from "./DocumentInvite.vue?vue&type=script&lang=js"
export * from "./DocumentInvite.vue?vue&type=script&lang=js"
import style0 from "./DocumentInvite.vue?vue&type=style&index=0&id=c0a1c32c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports